// extracted by mini-css-extract-plugin
export var contrastLow = "_2q-1";
export var externalLink = "_2q-2";
export var externalLinkIcon = "_2q-3";
export var link = "_2q-0";
export var linkLabel = "_2q-4";